import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './BasicInfo.module.less';

type MetricProps = {
  label: string;
  className?: string | undefined;
  value: string | null;
};

const Metric = ({ label, value, className }: MetricProps) => {
  if (!value) return null;
  return (
    <li className={cn(className, s.metric)}>
      <label className={s.metricLabel}>{label}</label>
      <div className={s.metricValue}>{value}</div>
    </li>
  );
};

type Props = {
  inventory: string | null;
  space: string | null;
  underConstruction: string | null;
  premierRetailDestinations: string | null;
};

const BasicInfo = ({ inventory, space, underConstruction, premierRetailDestinations }: Props) => {
  const { t } = useTranslation('landlord');

  return (
    <ul className={s.container}>
      <Metric label={t('inventory')} value={inventory} />
      <Metric label={t('space')} value={space} />
      <Metric label={t('underConstruction')} value={underConstruction} />
      <Metric
        label={t('premierRetailDestinations')}
        className={s.onlyOnDesktop}
        value={premierRetailDestinations}
      />
      <Metric
        label={t('premierRetail')}
        className={s.hideOnDesktop}
        value={premierRetailDestinations}
      />
    </ul>
  );
};

export default BasicInfo;
